"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCar = addCar;
exports.default = void 0;
exports.deleteCar = deleteCar;
exports.getCarList = getCarList;
exports.getCarStatistics = getCarStatistics;
exports.updateCar = updateCar;

var _request = _interopRequireDefault(require("@/utils/request"));

function getCarList(params) {
  return (0, _request.default)({
    url: 'api/car',
    method: 'get',
    params: params
  });
}

function addCar(data) {
  return (0, _request.default)({
    url: 'api/car',
    method: 'post',
    data: data
  });
}

function updateCar(data) {
  return (0, _request.default)({
    url: 'api/car',
    method: 'put',
    data: data
  });
}

function deleteCar(id) {
  return (0, _request.default)({
    url: "api/car/".concat(id),
    method: 'delete'
  });
}

function getCarStatistics() {
  return (0, _request.default)({
    url: 'api/car/statistics',
    method: 'get'
  });
}

var _default = {
  getCarList: getCarList,
  addCar: addCar,
  updateCar: updateCar,
  deleteCar: deleteCar,
  getCarStatistics: getCarStatistics
};
exports.default = _default;